/**
 * `redux-store/saga` (the ROOT saga) — the COMMON half. Present because rule 4 requires all
 * three files; it holds no code today.
 *
 * **Which kind of divergence is this? STRUCTURAL, and it is data rather than logic.** Both
 * variants are the same three lines — `yield all([...])` over every domain saga's default
 * export — but the ARRAY differs, in two ways that cannot be reconciled without changing
 * behaviour:
 *
 *   - **membership.** One platform runs 27 domain sagas, the other 24. The three extra ones
 *     each already exist as a single-variant folder in this tree, precisely because only one
 *     app has them.
 *   - **order.** `all()` forks its array in order, so the first synchronous tick of every
 *     `takeEvery`/`takeLatest` watcher is ordered by this list. One platform starts with the
 *     catalogue saga; the other hoists the table-view saga to the front. That is transcribed
 *     as-is — nothing observed depends on it, but nothing proves it does not either.
 *
 * A `shared.ts` that exported a "build the root from a list" helper would collapse both of
 * those into one call, which is exactly the kind of invented abstraction this migration does
 * not do: the point is that each app's boot sequence stays byte-for-byte what it is today.
 *
 * ⚠️ Each variant DEEP-IMPORTS its matching sibling variant rather than the bare folder.
 * That is hazard 6/16: a bare folder import inside `packages/core` resolves to the native
 * variant for `tsc` whatever file is doing the importing, so a platform file naming a bare
 * folder would typecheck against the other platform's saga.
 */
import customerDisplaySaga from "./customerDisplay";

export function createSharedSagas() {
  return [customerDisplaySaga()];
}
